import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.validateStoredSession().pipe(
    map(valid => {
      if (valid) return true;
      if (authService.wasLastRefreshTerminal()) return router.createUrlTree(['/login']);
      // Fallo pasajero (red, servidor, demasiadas solicitudes): dentro de la
      // app no se saca a nadie de una sesión que puede seguir siendo válida.
      // Pero en la PRIMERA carga no hay pantalla donde quedarse (antes se veía
      // en blanco): se muestra el login, que vuelve a intentar restaurarla.
      return router.navigated ? false : router.createUrlTree(['/login']);
    })
  );
};

